import React from 'react';
import { COMPANY_INFO } from '../../config/constants';

const Footer = ({ setCurrentPage }) => {
  // Handler function to open legal pages in new window
  const openLegalPage = (type, e) => {
    e.preventDefault();
    window.open(`?page=legal&type=${type}`, '_blank');
  };

  return (
    <footer className="bg-gray-800 text-white py-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold">{COMPANY_INFO.name}</h3>
            <p className="text-gray-300">{COMPANY_INFO.tagline}</p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-3">Quick Links</h4>
            <div className="flex flex-col space-y-2">
              <button onClick={() => setCurrentPage('home')} className="text-gray-300 hover:text-white bg-transparent border-0 p-0 text-left">About</button>
              <button onClick={(e) => openLegalPage('privacy', e)} className="text-gray-300 hover:text-white bg-transparent border-0 p-0 text-left">Privacy</button>
              <button onClick={(e) => openLegalPage('terms', e)} className="text-gray-300 hover:text-white bg-transparent border-0 p-0 text-left">Terms</button>
              <button onClick={(e) => openLegalPage('user-agreement', e)} className="text-gray-300 hover:text-white bg-transparent border-0 p-0 text-left">User Agreement</button>
              <button onClick={() => setCurrentPage('feedback')} className="text-gray-300 hover:text-white bg-transparent border-0 p-0 text-left">Contact</button>
            </div>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-700 pt-4 text-center text-gray-300">
          <p>&copy; {new Date().getFullYear()} MenuAnalyzer.AI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
